import React from 'react';
import { EMAILS } from '../constants';

import styles from './emails.scss';

interface IEmail {
  title: string,
  value: string,
}

const renderEmail = (item: IEmail, i: number) => (
  <div
    key={ i }
    className={ styles.section }
  >
    <div className={ styles.emailTitle }>{ item.title }</div>
    <div>
      <a href={ `mailto:${ item.value }` }>{ item.value }</a>
    </div>
  </div>
);

const Emails = () => (
  <div className={ styles.emailWrapper }>
    <div className={ styles.title }>Fanatical 24x7 Support by Email</div>
    <div className={ styles.column }>
      { EMAILS.products.map(renderEmail) }
    </div>
    <div className={ styles.column }>
      { EMAILS.topics.map(renderEmail) }
    </div>
  </div>
);

export default Emails;
